import { userOnboardingApiClient, UserOnboardingData, UserOnboardingResponse, UserOnboardingStatusResponse } from '@/clients/userOnboardingApiClient';

export const userOnboardingService = {
  async getStatus(): Promise<UserOnboardingStatusResponse> {
    return userOnboardingApiClient.getStatus();
  },

  async savePersonalNumber(personalNumber: string): Promise<UserOnboardingResponse> {
    return userOnboardingApiClient.savePersonalNumber(personalNumber);
  },

  async saveUserOnboardingData(data: UserOnboardingData): Promise<UserOnboardingResponse> {
    return userOnboardingApiClient.saveUserOnboardingData(data);
  }
};